<template>
  <div class="out-line">
    <div class="out-line-head">
      <img src="../../images/contracts.png" class="img" />
      <div class="info">
        <div class="info-title">
          {{ outlineInfo.contracts_number }}
        </div>
        <div class="info-in">
          <span class="info-class">
            教学分类：
            <span class="info-class-it">{{ outlineInfo.classify_name }}</span>
          </span>
          <span class="info-class" v-if="outlineInfo.grade_name">
            年级：
            <span class="info-class-it">{{ outlineInfo.grade_name }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="out-line-info">
      <span>当前科目为</span>
      <span class="item">{{ outlineInfo.subject }}</span>
      ,
      <span>大纲内共</span>
      <span class="item">{{ outlineInfo.periods_num }}</span>
      课次，已完成
      <span class="item">{{ outlineInfo.confirm_periods_num }}</span>
      课次，预约
      <span class="item">{{ outlineInfo.dispatch_periods_num }}</span>
      课次，剩余
      <span class="item">{{ outlineInfo.left_periods_num }}</span>
      课次
    </div>
    <div class="out-line-table">
      <div class="out-line-table-head">
        <el-col v-for="item in columns" :span="item.span" :key="item.key">
          <span>
            {{ item.title }}
          </span>
        </el-col>
      </div>
      <div class="out-line-table-body">
        <div class="list-item" v-for="item in data" :key="item.id">
          <div class="list-item-title" @click="onShrink(item)">
            <img
              v-if="item.isShow"
              src="@/modules/stu/images/file/down.png"
              class="up-down"
            />
            <img
              v-else
              src="@/modules/stu/images/file/up.png"
              class="up-down"
            />
            <span>
              {{ item.title }}(含{{ item.child ? item.child.length : 0 }}个课次)
            </span>
          </div>
          <div class="list-item-title-info" v-show="item.isShow">
            <div v-for="data in item.child" :key="data.id">
              <el-col v-for="i in columns" :span="i.span" :key="i.key">
                <span :class="{ tableTitle: i.key == 'title' }" class="span">
                  <template v-if="data[i.key]">
                    <span v-if="i.key == 'arrange_time'">
                      {{ data.start_time | tsFormat("yyyy/MM/dd hh:mm") }}-{{
                        data.end_time | tsFormat("hh:mm")
                      }}
                    </span>
                    <span v-else>{{ data[i.key] }}</span>
                  </template>
                  <template v-else>
                    <span class="default">-</span>
                  </template>
                </span>
              </el-col>
            </div>
          </div>
        </div>
        <EmptyNew v-if="data && data.length <= 0" title="暂无数据"></EmptyNew>
      </div>
    </div>
  </div>
</template>

<script>
import EmptyNew from "@/components/EmptyNew.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";

const columns = [
  {
    key: "title",
    span: 10,
    title: "章节名称",
  },
  {
    key: "statusName",
    span: 4,
    title: "状态",
  },
  {
    key: "teacher",
    span: 5,
    title: "讲师",
  },
  {
    key: "arrange_time",
    span: 5,
    title: "课次时间",
  },
];
export default {
  name: "Outline",
  components: {
    EmptyNew,
  },
  data() {
    return {
      columns,
      outlineInfo: {},
      data: [],
    };
  },
  async created() {
    const data = await this.$http.get(
      `/api/app/arrange/contractItem/chapters/${this.$route.query.id}`,
    );
    this.outlineInfo = data;
    this.data = data.chapters || [];
    this.data.forEach(item => {
      item.isShow = false;
      item.child.forEach(i => {
        if (i.status == 1) {
          i.statusName = "已上课";
        } else if (i.status == 2) {
          i.statusName = "已排课";
        } else {
          i.statusName = "未排课";
        }
      });
    });
    triggerLoaded(this);
  },
  methods: {
    onShrink(item) {
      const ind = this.data.findIndex(data => item.id == data.id);
      if (ind != -1) {
        this.data[ind].isShow = !this.data[ind].isShow;
      }
      this.data = [...this.data];
    },
  },
};
</script>

<style scoped lang="scss">
.out-line {
  padding: 5px 24px 20px 24px;
  background: #fff;
  position: relative;
}
.out-line-head {
  padding-top: 24px;
  display: flex;
  .img {
    width: 47px;
    height: 47px;
    margin-right: 16px;
  }
  .info-title {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #000000;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    width: 800px;
  }
  .info-in {
    margin-top: 8px;
  }
  .info-class {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999999;
    .info-class-it {
      color: #333;
    }
    &:first-child {
      display: inline-block;
      margin-right: 80px;
    }
  }
}
.out-line-info {
  margin-top: 24px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #999999;
  .item {
    color: #333;
    display: inline-block;
    padding: 0 5px;
  }
}
.out-line-table-head {
  margin-top: 24px;
  padding: 0 12px;
  height: 48px;
  line-height: 48px;
  background: #f7f7f7;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #333333;
  overflow: hidden;
}
.out-line-table-body {
  overflow: hidden;

  .list-item {
    padding-bottom: 8px;
    border-bottom: 1px solid #e6e6e6;
  }
  .list-item-title {
    cursor: pointer;
    margin-top: 8px;
    height: 40px;
    padding: 0 12px;
    line-height: 40px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    color: #333333;
    .up-down {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-right: 4px;
    }
  }
  .list-item-title-info {
    overflow: hidden;
    //height: 40px;
    padding: 0 12px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
    .tableTitle {
      display: inline-block;
      margin-left: 24px;
    }
    .span {
      display: inline-block;
      width: 100%;
    }
    .default {
      display: inline-block;
      //margin-left: 10px;
    }
  }
}
</style>
